// 甜蜜惩罚漫画 · 剧情追踪站内容数据

export interface NavLink {
  label: string;
  path: string;
}

export const siteNav: NavLink[] = [
  { label: "首页", path: "/" },
  { label: "剧情主线", path: "/plot" },
  { label: "角色解析", path: "/characters" },
  { label: "分话解析", path: "/chapters" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];

export const siteName = "甜蜜惩罚漫画剧情追踪站";
export const siteSlogan = "追更剧情，不再迷路";
export const siteIntro =
  "以读者视角持续追踪《甜蜜惩罚漫画》的主线走向，梳理关键分话节点，盘点角色关系与人物命运，并不断更新结局线索。无论你是刚入坑的新读者，还是追到最新的老粉，都能在这里快速补上剧情脉络。";

export const stats = [
  { value: "120+", label: "分话解析" },
  { value: "32", label: "角色档案" },
  { value: "6", label: "主线篇章" },
  { value: "24h", label: "更新追踪" },
];

// 剧情主线时间线节点
export interface PlotNode {
  phase: string;
  title: string;
  range: string;
  summary: string;
  tags: string[];
}

export const plotTimeline: PlotNode[] = [
  {
    phase: "序章",
    title: "命运交锋的初次相遇",
    range: "第1-12话",
    summary:
      "故事从女主苏念因职场危机与集团继承人陆沉舟产生交易式相遇开始。一场以“合约”为名的纠缠，将两人绑进了彼此的生活，也为后续的感情走向埋下伏笔。",
    tags: ["初遇", "合约", "伏笔"],
  },
  {
    phase: "第一卷",
    title: "契约之下的试探与拉扯",
    range: "第13-38话",
    summary:
      "表面的冷静克制下，两人在一次次交锋中逐渐卸下防备。外人眼中的逢场作戏，开始出现连他们自己都未曾察觉的真心痕迹。主线从这里正式铺开。",
    tags: ["拉扯", "心动", "主线推进"],
  },
  {
    phase: "第二卷",
    title: "旧事重提与身份疑云",
    range: "第39-66话",
    summary:
      "一段尘封过往浮出水面，女主的身世线索与男主家族旧怨相互纠缠，原本单纯的男女情愫被卷入更大的博弈之中，关系出现第一次真正意义上的裂痕。",
    tags: ["反转", "身世", "冲突"],
  },
  {
    phase: "第三卷",
    title: "误会与和解的反复拉扯",
    range: "第67-90话",
    summary:
      "情感在误会、沉默与和解之间反复摇摆，配角关系网也在此阶段全面展开。读者追更热度最高的分话节点，也集中出现在这一阶段。",
    tags: ["虐心", "成长", "关系网"],
  },
  {
    phase: "第四卷",
    title: "风暴中心的抉择",
    range: "第91-110话",
    summary:
      "关键人物逐一登场，真正的幕后对手浮出水面。男女主在利益与真心之间做出选择，人物命运开始走向分叉，结局线索也在此阶段密集释放。",
    tags: ["高潮", "抉择", "结局线索"],
  },
  {
    phase: "终章·追踪中",
    title: "结局走向持续更新",
    range: "第111话至今",
    summary:
      "剧情进入收束阶段，官方更新放缓而线索增多。本站将结合最新分话持续盘点结局走向、人物命运与作者埋设的回收伏笔，为你提供第一时间的剧情追踪。",
    tags: ["结局", "更新中", "伏笔回收"],
  },
];

// 关键剧情节点
export interface KeyNode {
  chapter: string;
  title: string;
  desc: string;
  type: string;
}

export const keyNodes: KeyNode[] = [
  {
    chapter: "第15话",
    title: "第一次真心流露",
    desc: "一向克制的男主在危急时刻下意识护住女主，两人的关系首次出现超出交易层面的裂缝。",
    type: "感情线",
  },
  {
    chapter: "第42话",
    title: "身世秘密的起点",
    desc: "女主幼年照片被意外发现，正式开启贯穿全篇的身份疑云支线。",
    type: "主线反转",
  },
  {
    chapter: "第58话",
    title: "第一次真正决裂",
    desc: "家族旧怨被摆上台面，女主被迫在真相与感情之间做出表态，成为全篇虐心起点。",
    type: "冲突",
  },
  {
    chapter: "第76话",
    title: "和解与初吻",
    desc: "历经误解后的第一次坦诚相对，情感线迎来阶段性突破，被读者评为年度名场面。",
    type: "情感线",
  },
  {
    chapter: "第95话",
    title: "幕后对手登场",
    desc: "真正的幕后人物正面登场，揭露整条博弈线的真实面目，主线彻底进入白热化。",
    type: "高潮",
  },
  {
    chapter: "第108话",
    title: "结局前夜的关键抉择",
    desc: "男女主在利益与真心之间做出关键选择，结局走向的主要线索在此集中释放。",
    type: "结局线索",
  },
];

// 角色
export interface Character {
  id: string;
  name: string;
  role: string;
  alias: string;
  tag: string;
  desc: string;
  arc: string;
  fate: string;
  image: string;
}

export const characters: Character[] = [
  {
    id: "su-nian",
    name: "苏念",
    role: "女主角",
    alias: "「在利益与真心之间摇摆的清醒者」",
    tag: "成长型",
    desc: "聪明、克制、清醒，却也在一次次试探中逐渐沦陷。她的选择牵动着全篇感情线与主线走向，是读者代入感最强的角色。",
    arc: "从独立自持到坦然面对真心，经历身世疑云后完成自我认同的成长闭环。",
    fate: "结局线索指向她与男主的和解，但代价与归属仍是本站持续追踪的焦点。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20young%20Chinese%20businesswoman%20in%20a%20tailored%20blazer%20standing%20against%20a%20soft%20warm%20cream%20studio%20backdrop%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%20style%2C%20rose%20gold%20and%20blush%20tones%2C%20gentle%20diffused%20lighting%2C%20refined%20minimal%20background%20with%20faint%20floral%20silhouette%2C%20high%20detail%2C%20artistic%20atmosphere&width=800&height=1000&seq=char-sunian&orientation=portrait",
  },
  {
    id: "lu-chenzhou",
    name: "陆沉舟",
    role: "男主角",
    alias: "「外表冷静、内里偏执的掌控者」",
    tag: "腹黑系",
    desc: "集团继承人，习惯掌控一切，却在苏念面前一次次破例。他的偏执与克制构成全篇感情张力的核心。",
    arc: "从高高在上的掌控者，到愿意为在乎之人放下身段的转变，是全篇最完整的成长线之一。",
    fate: "结局线索显示他终将直面内心，但在旧怨与责任的夹缝中如何取舍仍是悬念。",
    image:
      "https://readdy.ai/api/search-image?query=Handsome%20Chinese%20businessman%20in%20a%20dark%20tailored%20suit%20with%20a%20composed%20intense%20expression%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%20style%2C%20deep%20charcoal%20and%20rose%20gold%20tones%2C%20soft%20warm%20studio%20lighting%2C%20minimal%20cream%20background%20with%20faint%20geometric%20floral%20motif%2C%20high%20detail%2C%20cinematic%20artistic%20atmosphere&width=800&height=1000&seq=char-lu&orientation=portrait",
  },
  {
    id: "lin-wanqing",
    name: "林晚晴",
    role: "女二 / 情敌",
    alias: "「看似无害、实则步步为营」",
    tag: "复杂型",
    desc: "表面温柔得体，却因执念而走向极端。她的存在不断考验男女主之间的信任，是情感线的重要推动力。",
    arc: "从边缘人物逐渐卷入主线，其动机与结局留白，是读者讨论度最高的配角之一。",
    fate: "结局线索对其命运的描绘较为模糊，是否能够自我和解仍待更新确认。",
    image:
      "https://readdy.ai/api/search-image?query=Graceful%20Chinese%20woman%20with%20a%20composed%20gentle%20yet%20ambiguous%20smile%20in%20an%20elegant%20soft%20dress%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%20style%2C%20muted%20rose%20and%20champagne%20tones%2C%20soft%20warm%20lighting%2C%20minimal%20cream%20studio%20background%20with%20faint%20petal%20silhouettes%2C%20high%20detail%2C%20artistic%20subtle%20atmosphere&width=800&height=1000&seq=char-lin&orientation=portrait",
  },
  {
    id: "gu-yanshen",
    name: "顾言深",
    role: "男二 / 医者",
    alias: "「温柔克制的守护者」",
    tag: "治愈系",
    desc: "温润内敛的医者，是女主在低谷时最可靠的退路。他的存在让读者在虐心主线中拥有喘息的空间。",
    arc: "作为旁观者与守护者贯穿全篇，其感情线的走向关乎男女主最终关系的稳定性。",
    fate: "结局线索显示他大概率选择体面退出，但作者是否留有翻转仍是悬念。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20gentle%20young%20Chinese%20male%20doctor%20in%20a%20light%20cardigan%20over%20a%20shirt%2C%20soft%20kind%20eyes%20and%20a%20calm%20smile%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%20style%2C%20warm%20beige%20and%20soft%20rose%20tones%2C%20soft%20diffused%20lighting%2C%20minimal%20cream%20background%20with%20faint%20botanical%20line%20art%2C%20high%20detail%2C%20tender%20artistic%20atmosphere&width=800&height=1000&seq=char-gu&orientation=portrait",
  },
  {
    id: "shen-qinghuan",
    name: "沈清欢",
    role: "关键配角",
    alias: "「贯穿身世谜团的引路人」",
    tag: "神秘系",
    desc: "身世疑云的关键人物，出场不多却次次精准推动主线。她的一句话往往预示着剧情走向的转折。",
    arc: "她的真实立场始终成谜，是理解整条身世支线最重要的钥匙。",
    fate: "结局线索表明她将在终章揭露关键真相，其归属直接决定主线收束方向。",
    image:
      "https://readdy.ai/api/search-image?query=Mysterious%20poised%20young%20Chinese%20woman%20with%20a%20distant%20knowing%20gaze%20in%20a%20dark%20elegant%20long%20coat%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%20style%2C%20deep%20plum%20and%20muted%20gold%20tones%2C%20moody%20soft%20warm%20lighting%2C%20minimal%20deep%20cream%20background%20with%20faint%20mist%2C%20high%20detail%2C%20enigmatic%20cinematic%20atmosphere&width=800&height=1000&seq=char-shen&orientation=portrait",
  },
];

// 分话
export interface ChapterItem {
  id: string;
  num: string;
  title: string;
  date: string;
  tag: string;
  summary: string;
  image: string;
}

export const chapters: ChapterItem[] = [
  {
    id: "c112",
    num: "第112话",
    title: "真相之门的最后一道锁",
    date: "最近更新",
    tag: "主线",
    summary:
      "沈清欢终于开口，指向多年的身世谜团。一扇尘封的门被推开，男女主的立场与旧怨迎来正面摊牌。",
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20ink-wash%20illustration%20of%20a%20heavy%20old%20wooden%20door%20slowly%20opening%20with%20warm%20golden%20light%20spilling%20through%2C%20romantic%20suspense%20atmosphere%2C%20deep%20rose%20and%20warm%20amber%20palette%2C%20soft%20painterly%20texture%2C%20minimal%20elegant%20composition%2C%20cinematic%20moody%20lighting%2C%20high%20detail&width=900&height=600&seq=ch-c112&orientation=landscape",
  },
  {
    id: "c110",
    num: "第110话",
    title: "风暴中心的短暂宁静",
    date: "一周前",
    tag: "过渡",
    summary:
      "大战前的片刻喘息。两人在雨夜天台的那段对话，被读者视为全篇最温柔的静默时刻。",
    image:
      "https://readdy.ai/api/search-image?query=Two%20silhouettes%20standing%20on%20a%20rooftop%20terrace%20in%20soft%20rain%20with%20city%20lights%20blurred%20in%20warm%20haze%2C%20dreamy%20romantic%20ink-wash%20editorial%20illustration%2C%20deep%20rose%20and%20muted%20amber%20tones%2C%20gentle%20melancholic%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=900&height=600&seq=ch-c110&orientation=landscape",
  },
  {
    id: "c108",
    num: "第108话",
    title: "结局前夜的抉择",
    date: "两周前",
    tag: "高潮",
    summary:
      "利益与真心被摆上天平，男主做出了让所有读者屏息的选择。结局走向的主要线索在本话集中释放。",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20balance%20scale%20with%20a%20single%20rose%20and%20a%20letter%20on%20a%20warm%20dark%20wooden%20table%2C%20dreamy%20romantic%20ink-wash%20illustration%2C%20deep%20rose%20red%20and%20warm%20gold%20palette%2C%20dramatic%20soft%20lighting%2C%20minimal%20cinematic%20composition%2C%20high%20detail%20artistic&width=900&height=600&seq=ch-c108&orientation=landscape",
  },
  {
    id: "c95",
    num: "第95话",
    title: "幕后对手正面登场",
    date: "上月",
    tag: "高潮",
    summary:
      "真正的幕后人物现身，揭开了贯穿多卷的博弈线真实面目，主线自此彻底进入白热化阶段。",
    image:
      "https://readdy.ai/api/search-image?query=A%20mysterious%20figure%20stepping%20out%20of%20deep%20shadow%20into%20warm%20candlelight%20in%20an%20opulent%20dark%20study%2C%20dreamy%20romantic%20ink-wash%20illustration%2C%20deep%20plum%20and%20muted%20gold%20tones%2C%20dramatic%20chiaroscuro%20lighting%2C%20minimal%20cinematic%20composition%2C%20high%20detail&width=900&height=600&seq=ch-c95&orientation=landscape",
  },
  {
    id: "c76",
    num: "第76话",
    title: "和解与初吻",
    date: "两月前",
    tag: "情感线",
    summary:
      "历经误解后的第一次坦诚相对，两人在樱花雨下迎来情感线的阶段性突破，成为公认的名场面。",
    image:
      "https://readdy.ai/api/search-image?query=Cherry%20blossom%20petals%20drifting%20in%20soft%20warm%20breeze%20over%20a%20quiet%20garden%20lane%20at%20dusk%2C%20two%20blurred%20figures%20close%20together%20under%20the%20trees%2C%20dreamy%20romantic%20ink-wash%20illustration%2C%20soft%20rose%20and%20peach%20gold%20tones%2C%20tender%20cinematic%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=900&height=600&seq=ch-c76&orientation=landscape",
  },
  {
    id: "c42",
    num: "第42话",
    title: "身世秘密的起点",
    date: "数月前",
    tag: "主线反转",
    summary:
      "一张泛黄的旧照片被意外发现，女主的身世疑云正式开启，全篇最重要的伏笔从本话展开。",
    image:
      "https://readdy.ai/api/search-image?query=A%20faded%20sepia%20photograph%20held%20by%20slender%20hands%20over%20a%20warm%20wooden%20desk%20with%20a%20magnifying%20glass%20and%20old%20letters%2C%20dreamy%20romantic%20ink-wash%20illustration%2C%20muted%20gold%20and%20warm%20brown%20tones%2C%20soft%20nostalgic%20lighting%2C%20minimal%20cinematic%20composition%2C%20high%20detail&width=900&height=600&seq=ch-c42&orientation=landscape",
  },
];

// 分话详情正文段落
export interface ChapterDetail {
  intro: string;
  sections: { heading: string; body: string[] }[];
  highlights: string[];
}

export const chapterDetailMap: Record<string, ChapterDetail> = {
  c112: {
    intro:
      "作为当前更新的最新分话，第112话把整条身世支线推向了摊牌临界点。沈清欢终于正面开口，而她说出的每一个字，都在动摇男女主此前辛苦维持的平衡。",
    sections: [
      {
        heading: "本话核心：门后的真相",
        body: [
          "开篇即是以沈清欢的第一视角切入，长镜头的调度让紧张感层层累积。她话里的每个停顿，都成为读者争相解读的细节。",
          "本话用「门」作为贯穿意象，既有实体的旧宅大门，也隐喻男女主之间那道始终没有完全打开的心门。当门被推开，旧的误会与新的真相同时涌出。",
        ],
      },
      {
        heading: "人物反应拆解",
        body: [
          "苏念的冷静在这一话出现罕见的裂缝，她对真相的第一反应不是质问，而是沉默——这与其一贯的清醒人设高度契合，也说明她对结局其实早有预感。",
          "陆沉舟在本话的戏份较少，却通过一个握拳的细节把内心的挣扎传递到位。编剧刻意把情绪留给读者自行填补，是典型的留白式写法。",
        ],
      },
      {
        heading: "伏笔与回收信号",
        body: [
          "本话回收了第42话身世照片、第58话家族旧怨两条长期伏笔，同时埋下终章的新线索。第112话里反复出现的旧钟表，很可能预示着时间与和解的最终主题。",
          "结合官方放出的预告，结局方向已较为明朗，但代价归属仍留有悬念，本站将持续追踪。",
        ],
      },
    ],
    highlights: ["身世真相正式摊牌", "「门」意象贯穿全话", "旧怨与和解主题并置", "结局线索进一步收束"],
  },
  c110: {
    intro:
      "第110话是一段情绪上的缓冲带。在大战前夕，作者选择用一场雨夜天台对话，让两位主角获得片刻喘息，也让读者在紧张的主线中稍稍放松。",
    sections: [
      {
        heading: "静默中的情感暗涌",
        body: [
          "整话几乎全靠眼神与留白推进，台词极少，却把两人之间没说出口的牵挂表达得淋漓尽致。这种「少即是多」的处理，是全篇最擅长的高光段落。",
        ],
      },
      {
        heading: "位置安排的意义",
        body: [
          "作者将这段温柔戏刻意放在风暴之前，形成强烈的情绪对比。它既是主角的体面告别，也是读者眼中的「暴风雨前的宁静」。",
        ],
      },
    ],
    highlights: ["全篇最温柔静默时刻", "台词极简、留白拉满", "风暴前的重要情绪锚点"],
  },
  c108: {
    intro:
      "第108话是公认的「结局前夜」。当利益与真心被摆上天平，男主终于做出了让所有读者屏息的选择，也让整条主线走向第一次有了清晰的方向。",
    sections: [
      {
        heading: "天平的意象",
        body: [
          "本话以象征性的天平开场，一边是家族的责任与旧怨，一边是贯穿全篇的真心。作者用极具仪式感的构图，把抽象的抉择具象化。",
          "男主的最终选择在粉丝中引发了长达数周的讨论，无论站哪一边，都认可这一处理让人物弧光完整。",
        ],
      },
      {
        heading: "结局线索盘点",
        body: [
          "本话释放了多条结局线索：男主的选择、女主的反应、沈清欢的暗示，三者共同指向一个相对明朗但仍留有余地的收束方向。",
        ],
      },
    ],
    highlights: ["利益与真心的正面抉择", "极具仪式感的天平构图", "结局走向主要线索集中释放"],
  },
  c95: {
    intro:
      "第95话是主线彻底白热化的转折点。幕后人物正面登场，让此前多卷铺垫的博弈线第一次有了清晰的对手轮廓。",
    sections: [
      {
        heading: "对手的登场",
        body: [
          "作者用逆光出场的方式揭开对手真容，既保留了悬念，也让旧怨的脉络在本话得到集中回收。自此，男女主面对的已不只是感情问题，而是一场更大的博弈。",
        ],
      },
      {
        heading: "对后续的影响",
        body: [
          "本话之后，分话节奏明显加快，情绪张力一路走高，也直接为终章的高潮埋下了决定性伏笔。",
        ],
      },
    ],
    highlights: ["幕后对手真容揭晓", "旧怨脉络集中回收", "主线进入白热化阶段"],
  },
  c76: {
    intro:
      "第76话是感情线的阶段性高光。历经数卷的误会与拉扯，两人在樱花雨下的第一次坦诚相对，成为读者公认的名场面。",
    sections: [
      {
        heading: "名场面的构成",
        body: [
          "樱花、黄昏、安静的街道，作者用极为克制的画面语言，把两人之间积压已久的情感在一瞬间释放。没有多余的对白，只有动作与眼神。",
        ],
      },
      {
        heading: "在主线中的位置",
        body: [
          "这一话既是感情线的阶段性突破，也是后续身世主线爆发前的最后温情。它的存在让此后的虐心更具冲击力。",
        ],
      },
    ],
    highlights: ["全篇公认名场面", "樱花雨下的第一次坦诚", "转折前的最后温情"],
  },
  c42: {
    intro:
      "第42话是身世支线的起点。一张泛黄的旧照片被意外发现，将女主的身世疑云正式摆上台面，成为全篇最重要的长期伏笔之一。",
    sections: [
      {
        heading: "伏笔的开启",
        body: [
          "本话用一张旧照片为引，自然地带出女主被刻意掩盖的过去。此后数十话，这条线始终若隐若现，直到终章才迎来集中回收。",
        ],
      },
      {
        heading: "为读者埋下的钩子",
        body: [
          "作者在本话埋下的身份疑云，正是后来多条反转与情感冲突的根本来源，也被认为是全篇叙事结构中最精妙的一环。",
        ],
      },
    ],
    highlights: ["全篇最重要的长期伏笔", "旧照片引出身份疑云", "叙事结构的精巧一环"],
  },
};

// 分话列表（供列表页使用）
export const chapterList = [
  { id: "c112", num: "第112话", title: "真相之门的最后一道锁", tag: "主线", date: "最近更新" },
  { id: "c110", num: "第110话", title: "风暴中心的短暂宁静", tag: "过渡", date: "一周前" },
  { id: "c108", num: "第108话", title: "结局前夜的抉择", tag: "高潮", date: "两周前" },
  { id: "c95", num: "第95话", title: "幕后对手正面登场", tag: "高潮", date: "上月" },
  { id: "c76", num: "第76话", title: "和解与初吻", tag: "情感线", date: "两月前" },
  { id: "c42", num: "第42话", title: "身世秘密的起点", tag: "主线反转", date: "数月前" },
];

// 常见问题
export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "甜蜜惩罚漫画目前更新到第几话了？",
    a: "截至目前，甜蜜惩罚漫画主线已更新至第112话，剧情进入终章的收束阶段。本站会随着官方更新及时同步最新分话进度与剧情追踪内容，建议收藏本站以便第一时间查看更新。",
  },
  {
    q: "甜蜜惩罚漫画的主线剧情是什么？",
    a: "主线围绕女主角苏念与集团继承人陆沉舟展开，从一场交易式的相遇开始，逐步卷入身世疑云与家族旧怨的博弈之中，并在感情线的拉扯与主线反转中不断推进。详细脉络可前往「剧情主线」页面查看分卷梳理。",
  },
  {
    q: "哪些分话是剧情的关键节点？",
    a: "第42话开启身世支线，第58话出现第一次真正决裂，第76话达成和解，第95话幕后对手登场，第108话是结局前夜的抉择。建议重点追读这几话，可前往「分话解析」页面查看单话详解。",
  },
  {
    q: "男女主的感情线走向如何？",
    a: "男女主的关系经历了试探、拉扯、决裂、和解的完整弧线，目前剧情已进入结局前的关键阶段。感情线与身世主线相互交织，最终走向仍需结合后续更新持续追踪，本站会在关键节点及时更新分析。",
  },
  {
    q: "甜蜜惩罚漫画的结局线索有哪些？",
    a: "从目前的分话来看，结局方向已相对明朗：身世真相将迎来集中回收，男主在利益与真心之间做出了选择，但最终代价与归属仍留有悬念。本站将持续结合最新分话盘点结局走向与伏笔回收。",
  },
  {
    q: "这个网站的内容是官方发布的吗？",
    a: "本网站是面向读者的剧情追踪与解读站点，属于读者向的内容梳理，并非官方发布渠道。所有剧情分析均基于已公开分话整理，仅供参考，具体以官方更新内容为准。",
  },
];

// 专题推荐
export interface Topic {
  title: string;
  path: string;
  desc: string;
  tag: string;
}

export const topics: Topic[] = [
  {
    title: "身世疑云全梳理",
    path: "/plot",
    desc: "一张旧照片牵出的整条身世支线，从第42话到终章，帮你一次看清来龙去脉。",
    tag: "主线专题",
  },
  {
    title: "感情线弧光复盘",
    path: "/characters",
    desc: "从试探、拉扯到和解，两位主角的成长线到底经历了哪些关键节点。",
    tag: "角色专题",
  },
  {
    title: "伏笔回收时间轴",
    path: "/chapters",
    desc: "作者埋下的长期伏笔与回收信号，逐条盘点，追更不再错过细节。",
    tag: "分话专题",
  },
];

export const footerLinks = {
  站点导航: [
    { label: "剧情主线", path: "/plot" },
    { label: "角色解析", path: "/characters" },
    { label: "分话解析", path: "/chapters" },
    { label: "常见问题", path: "/faq" },
  ],
  关于本站: [
    { label: "关于我们", path: "/about" },
    { label: "站点说明", path: "/about" },
    { label: "内容声明", path: "/about" },
  ],
};